import { storyblokEditable } from "gatsby-source-storyblok"

import ThirdsHero from "."

import {
  isConsolidatedPurchasableItem,
  useGetConsolidatedItem,
} from "@hooks/V2/storyblok/useConsolidatedItem"
import { storyblokLinkToYocoLink } from "@utils/storyblok"
import React from "react"

const StoryblokProductThirdsHero = ({
  blok,
}: Storyblok.BlokProps<Storyblok.ProductThirdsHero>) => {
  const getConsolidatedItem = useGetConsolidatedItem()

  const products = blok.products?.flatMap((product) => {
    const consolidatedItem = getConsolidatedItem(product)

    return isConsolidatedPurchasableItem(consolidatedItem)
      ? consolidatedItem
      : []
  })

  const getCtaLink = () => storyblokLinkToYocoLink(blok.ctaLink)

  return (
    <ThirdsHero
      headingSuperscript={blok.headingSuperscript}
      heading={blok.heading}
      headingSize={blok.headingSize}
      description={blok.description}
      highlightedDescriptionText={blok.highlightedDescriptionText}
      imageUrl={blok.image?.filename}
      imageAlt={blok.image?.alt}
      products={products}
      videoUrl={blok.video?.filename}
      ctaText={blok.ctaText}
      ctaLink={getCtaLink()}
      backgroundColor={blok.backgroundColor}
      linkToPurchase={blok.linkToPurchase}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokProductThirdsHero
